import { Component, JSX } from 'solid-js';

export interface BulletPointProps {
    children: JSX.Element;
}
const BulletPoint: Component<BulletPointProps> = (props) => {
    return (
        <p
            classList={{}}
            class="text-secondary-white font-medium text-sm leading-6"
        >
            <span class="w-2 inline-block" />
            •
            <span class="w-5 inline-block" />
            {props.children}
        </p>
    );
};

export default BulletPoint;
